import axios from "axios";

export const downloadOrderRawScrapInventoryReport = async () => {
    try {
        const config = {
            withCredentials: true,
            headers: {
                withCredentials: true,
            },
        };
        const url = `${process.env.REACT_APP_URL
            }/api/raw-inventory/download-csv-orders-raw-scrapped-inventory`;
        const data = await axios.get(url, config);
        return data?.data?.result;
    } catch (error) {
        console.log(error);
        return error?.response?.data?.result;
    }
};
